import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import { FilerCodeDetailsModel } from '@data-layer/models/companies';
import { PortModel } from '@data-layer/models/common';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'self-filer-code-form',
  templateUrl: './self-filer-code-form.component.html',
  styleUrls: ['./self-filer-code-form.component.scss'],
})
export class SelfFilerCodeFormComponent implements OnInit, OnChanges {
  @Input() public filerCodeInfo: FilerCodeDetailsModel;
  @Input() public companyId: number;
  @Input() public additionalPorts: PortModel[] = [];
  @Output() public update: EventEmitter<any> = new EventEmitter();
  @Output() public updateABI: EventEmitter<boolean> = new EventEmitter<boolean>();

  public fg: UntypedFormGroup = new UntypedFormGroup({
    abiTransmitterUpdateApproved: new UntypedFormControl(false),
  });

  constructor(private router: Router) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.filerCodeInfo) {
      this.fg.patchValue({ abiTransmitterUpdateApproved: changes.filerCodeInfo.currentValue.abiTransmitterUpdateApproved });
      if (changes.filerCodeInfo.currentValue.abiTransmitterUpdateApproved) {
        this.fg.get('abiTransmitterUpdateApproved').disable();
      } else {
        this.fg.get('abiTransmitterUpdateApproved').enable();
      }
    }
  }

  public get currentUrl() {
    return this.router.url;
  }

  public get isSent(): boolean {
    return !!(this.filerCodeInfo && this.filerCodeInfo.requestSentTimestamp);
  }

  public get isHasFilerCode(): boolean {
    return !!(this.filerCodeInfo && this.filerCodeInfo.filerCode && this.filerCodeInfo.detailsSetTimestamp);
  }

  public afterUpdate() {
    this.update.emit();
  }

  public updateAbiTransmitter(value: boolean): void {
    this.fg.get('abiTransmitterUpdateApproved').disable();
    this.updateABI.emit(value);
  }
}
